import React from 'react';
import { CONTRACT_DISCLAMER_TEXT } from '../../../config/text/text';

const VoucherContractDisclamer = () => {
  return (
    <>
      <div className="voucher-contract-disclamer">
        {CONTRACT_DISCLAMER_TEXT}
      </div>
      <style jsx>{`
        .voucher-contract-disclamer {
          font-size: 11px;
          margin: 10px 0 10px 0;
          text-align: justify;
        }
      `}</style>
    </>
  );
};

export default VoucherContractDisclamer;
